// extracted by mini-css-extract-plugin
export default {"container":"Books_container__vHK8J","booksContainer":"Books_booksContainer__20rtT","list":"Books_list__mlK3Q","empty":"Books_empty__+ZvV0","loadMoreBtn":"Books_loadMoreBtn__gXAQw"};